import { Checkbox, FormControlLabel } from "@material-ui/core";
import clsx from "clsx";
import React from "react";
import { lynxCheckBoxStyles } from "./LynxCheckBoxStyles";
import { ReactComponent as Check } from "../../icons/CheckboxIcon.svg";
import { LynxCheckBoxProps } from "./LynxCheckBoxProps";

export function LynxCheckBox(props: LynxCheckBoxProps) {
    const { size = "small" } = props;
    const classes = lynxCheckBoxStyles({
        checked: props.checked,
        size,
        disabled: props.disabled,
    });

    const labelClassName = clsx(classes.labelRoot, props.labelClassName);
    const className = clsx(classes.checkboxRoot, props.className);

    const icon = <span className={classes.icon}></span>;
    const checkedIcon = (
        <span className={clsx(classes.icon, classes.checkedIcon)}>
            <Check />
        </span>
    );

    const checkBox = (
        <Checkbox
            {...props}
            className={className}
            checkedIcon={checkedIcon}
            icon={icon}
        />
    );

    return (
        <FormControlLabel
            className={labelClassName}
            control={checkBox}
            label={props.label}
        />
    );
}
